import React, { Component } from 'react';
import { Route, HashRouter as Router, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import actions from '@/app/actions.js';
import { connect } from 'react-redux';
import TopNav from '../component/topNav';
import Home from './home';
import List from './list';
import { TopNavData, flat } from '../component/config';
import './mkdown.css';
import './leftnav.css';
import Search from '../component/search';
import NewlastRecommend from './NewlastRecommend';
import { reportUserBehaviorCgi, getAccountInfo } from '@/api/cgi/common';
import { getCatalogList } from '@/api/cgi/knowledge';
import cookie from '@/utils/cookie';
import { Loading } from '@tencent/spaui';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: {},
      knowledge_token: '',
      NavData: [],
      sidebarData: [],
      tabValue: '',
      sidebarValue: '',
      catalog_id: 1,
      isCgiDone: false,
      searchStatus: false,
    };
    this.currentDayTime = Date.now();

    this.getAccountInfo = this.getAccountInfo.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.getCatalogList = this.getCatalogList.bind(this);
    this.handleNavData = this.handleNavData.bind(this);
    this.handleSidebarChange = this.handleSidebarChange.bind(this);
    this.getSearchStatus = this.getSearchStatus.bind(this);
  }

  componentDidMount() {
    this.getAccountInfo();
    const data = {
      behavior: '打开页面',
      page1: '知识',
      page2: '知识库',
      page3: '首页',
    };
    this.reportUserBehavior(data);
    const param1 = {
      behavior: '曝光数量V2',
      page1: '知识',
      page2: `知识库-${this.currentDayTime}`,
      page3: '内容中台文章详情',
      relation_id: 1,
      relation_type: '-',
    };
    reportUserBehaviorCgi({ data: param1 });
  }

  reportUserBehavior = (data) => {
    reportUserBehaviorCgi({ data });
  }

  getSearchStatus(status) {
    this.setState({ searchStatus: status });
  }

  getAccountInfo() {
    const self = this;
    const dispatch = this.props.dispatch;
    return getAccountInfo()
      .then((response) => {
        const { data = {}, code } = response;
        if (code == 0 && data) {
          const { knowledge_token } = data;
          dispatch({
            type: actions.knowledgeTypes.info,
            response: data,
          });
          window.sessionStorage.setItem('knowledge_token', knowledge_token);

          this.setState({ account: data, knowledge_token });
        }
      })
      .then(() => {
        self.setState(
          {
            isCgiDone: true,
          },
          (_) => this.getCatalogList(),
        );
      });
  }

  getCatalogList() {
    const { knowledge_token } = this.state;
    const tabValue = window.location.hash.split('/')[3];
    getCatalogList({ data: { knowledge_token } }).then((res) => {
      const { data = [], code } = res;
      if (code == 0 && data) {
        this.setState({ NavData: data }, (_) => {
          this.handleTabChange(_, tabValue);
        });
      }
    });
  }

  handleTabChange(e, tabValue, childId, childCId) {
    this.setState({ tabValue }, (_) => this.handleNavData(childId, childCId));
    this.props.dispatch({
      type: actions.knowledgeTypes.catalogList,
      response: [],
    });
  }

  handleSidebarChange(e, value) {
    const { dispatch } = this.props;
    if (!value) return false;
    this.setState({ sidebarValue: value.key });
    dispatch({
      type: actions.knowledgeTypes.catalogList,
      response: [],
    });
    if (typeof value.has_post !== 'undefined') {
      dispatch({
        type: actions.knowledgeTypes.catalogId,
        response: { value: value.key },
      });
      if (value.key) {
        const param = {
          behavior: '打开页面',
          page1: '知识',
          page2: '知识库',
          page3: '文章目录',
          relation_id: value.key,
          relation_name: value.label,
        };
        reportUserBehaviorCgi({ data: param });
        const param1 = {
          behavior: '曝光数量V2',
          page1: '知识',
          page2: `知识库-${this.currentDayTime}`,
          page3: '内容中台文章详情',
          relation_id: 2,
          relation_type: '-',
        };
        reportUserBehaviorCgi({ data: param1 });
      }
    } else {
      if (value.isThird && value.thirdData.length > 0) {
        dispatch({
          type: actions.knowledgeTypes.catalogList,
          response: value.thirdData,
        });
        dispatch({
          type: actions.knowledgeTypes.catalogId,
          response: {
            value: value.thirdData[0] ? value.thirdData[0].key : '',
            name: value.label,
          },
        });
        const param = {
          behavior: '打开页面',
          page1: '知识',
          page2: '知识库',
          page3: '文章目录',
          relation_id: value.thirdData[0] ? value.thirdData[0].key : '',
          relation_name: value.thirdData[0] ? value.thirdData[0].label : '',
        };
        reportUserBehaviorCgi({ data: param });
      } else {
        dispatch({
          type: actions.knowledgeTypes.catalogList,
          response: [],
        });
      }
    }
  }

  handleNavData(childId, childCId) {
    const { NavData, tabValue } = this.state;
    let result = [];
    if (tabValue == '') return result;
    for (let i = 0; i < NavData.length; i++) {
      if (NavData[i].catalog_id == tabValue) {
        result = NavData[i].children;
        break;
      }
    }
    result = TopNavData(result, tabValue);
    if (_.isEmpty(result)) {
      this.props.dispatch({
        type: actions.knowledgeTypes.catalogId,
        response: { value: tabValue },
      });
    }
    this.setState({ sidebarData: result }, (e) => {
      let val = null;
      const second = window.location.hash.split('/')[3]; // 二级导航id
      const third = (window.location.hash.split('/')[4] || '').split('?')[0]; // 三级导航id
      const sidebarValue = _.find(flat(this.state.sidebarData), (v) => (third ? v.key === +third : v.key === +second)) || {};
      if (sidebarValue.data && !_.isEmpty(sidebarValue.data)) {
        val = sidebarValue.data[0];
      } else {
        val = sidebarValue;
      }
      this.handleSidebarChange(e, val);
    });
  }

  render() {
    const { account, NavData, tabValue, sidebarData, sidebarValue, isCgiDone, searchStatus } = this.state;
    if (!isCgiDone) return <Loading type="svg" display="center" delay={100} />;
    return (
      <Router>
        <TopNav account={account} NavData={NavData} tabValue={tabValue} getSearchStatus={this.getSearchStatus} onChange={this.handleTabChange} />
        <div className="help_wrapper help-category  ">
          <Switch>
            {/* {!!tabValue ? <Redirect exact from="/" to={"/all"} /> : <Redirect exact from="/list" to={"/all"} />} */}
            <Redirect exact from="/" to={'/all'} />
            <Route path="/all">
              <Home NavData={NavData} onChange={this.handleTabChange} />
            </Route>
            <Route path="/list/*">
              <List tabValue={tabValue} sidebarData={sidebarData} sidebarValue={sidebarValue} handleSidebarChange={this.handleSidebarChange} />
            </Route>
            <Route path={'/search/:keyword'} component={Search}></Route>
            <Route path={'/newlastRecommend'} component={NewlastRecommend}></Route>
            <Route path="/">
              <Home NavData={NavData} onChange={this.handleTabChange} />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default connect()(Layout);
